import React, {useEffect, useState} from 'react';
import Header from '../../components/Header';
import {Footer} from '../../components/Footer';
import {BetInSchema, BetSchema, BetsService, MatchesService, MatchWithBetSchema, UserScoreSchema} from "../../api";
import {IconFunnel} from "@consta/uikit/IconFunnel";
import {useAlert} from "../../contexts/AlertContext";
import {Skeleton} from "../../components/Skeleton";
import {Rating} from "../../components/Rating";
import {MatchCard} from "../../components/MatchCard";

function Matches() {
    const [matches, setMatches] = useState<MatchWithBetSchema[]>([]);
    const [editingBet, setEditingBet] = useState<BetInSchema>();
    const [loading, setLoading] = useState<boolean>(true);
    const [betLoading, setBetLoading] = useState<boolean>(false);
    const [place, setPlace] = useState<UserScoreSchema>();
    const [filterFinished, setFilterFinished] = useState(true);
    const { infoTip, errorTip } = useAlert();

    useEffect(() => {
        Promise.all([
            BetsService.getUserScore(),
            MatchesService.listMatchesWithBet(),
        ]).then(([userScoreData, matchesData]) => {
            setPlace(userScoreData);
            setMatches(matchesData);
        }).finally(() => setLoading(false));
    }, []);

    const handleSubmitBet = (match_id: number, bet?: BetSchema) => {
        setBetLoading(true);
        if (editingBet) {
            let response;
            if (bet) {
                response = BetsService.updateBet(bet.id!, editingBet);
            } else {
                response = BetsService.createBet(editingBet);
            }
            response
                .then((data: BetSchema) => {
                    setMatches(
                        matches.map(match => (match.id === match_id ? { ...match, bet: data } : match))
                    )
                })
                .then(() => infoTip('Ставка сделана!'))
                .then(() => setEditingBet(undefined))
                .then(() => {
                    BetsService.getUserScore().then((data) => setPlace(data));
                })
                .catch((err) => {
                    errorTip(err.body?.detail ?? err.toString());
                    return Promise.reject(err);
                })
                .finally(() => setBetLoading(false));
        }
    };

    if (loading) return <Skeleton />;

    return (
        <>
            <Header />
            {matches && (
                <div className='tournament'>
                    {place && <Rating place={place} />}
                    <h2 className='tournament__title'>Прогнозы</h2>
                    <p className='tournament__subtitle'>
                        Укажи точный счёт на каждый матч. Менять прогноз можно до начала игры. На матчи плей-офф можно указать доп. время и пенальти.
                    </p>
                    <div className='matches__buttons'>
                        <button
                            className={`matches__filter-btn ${!filterFinished ? 'matches__filter-btn--active' : ''}`}
                            onClick={() => setFilterFinished(!filterFinished)}
                        >
                            <IconFunnel size='s' />
                            <span>{filterFinished ? 'Показать прошедшие' : 'Скрыть прошедшие'}</span>
                        </button>
                    </div>
                </div>
            )}
            {matches && (
                <div className='matches'>
                    {matches
                        .filter((match) => (match.name && (!filterFinished || match.status !== 'CLOSED')))
                        .map((match) => (
                            <MatchCard
                                key={match.id}
                                match={match}
                                place={place}
                                editingBet={editingBet}
                                betLoading={betLoading}
                                onEdit={setEditingBet}
                                onCancel={() => setEditingBet(undefined)}
                                onSave={handleSubmitBet}
                            />
                        ))}
                </div>
            )}
            <Footer />
        </>
    );
}
export { Matches };
